import React, { useState, useEffect } from 'react';
import {
    Container,
    Header as HeaderRS,
    Content,
    Footer,
    Sidebar as Side
} from 'rsuite';

import { api } from '../../../services/api';
import Navbarr from '../../../components/Navbar';
import CardMap from '../../../components/CardMap';

import './styles.css';

export default function Map({ sidebar: Sidebar, ...props }) {

    const [mapState, setMapState] = useState({
        loadingUsers: true,
        loadingProducts: true,
        loadingCompet: true,
        visits: [],
        users: [],
        ownProducts: [],
        compProducts: [],
    });
    useEffect(() => {
        async function fetchUsers() {
            try {
                const usersData = await api.getUsers();

                const activeUsers = usersData.filter(
                    item => item['role'] === 'ROLE_USUARIO' && item['status'] === 'ATIVO'
                );

                const auxUsers = [
                    { email: "Todos", nome: "Todos", status: "TODOS" },
                    ...activeUsers
                ];

                setMapState(prevState => ({
                    ...prevState,
                    loadingUsers: false,
                    users: auxUsers,
                }));
            } catch (err) {
                console.error("Falha ao obter usuários: ", err);
            }
        }

        async function fetchOwntProducts() {
            try {
                const productsData = await api.getOwnProducts();
                const auxProducts = productsData.sort((a, b) => {
                    if (a['nome'] < b['nome']) return -1;
                    if (a['nome'] > b['nome']) return 1;
                    return 0;
                });
                setMapState(prevState => ({
                    ...prevState,
                    loadingProducts: false,
                    ownProducts: auxProducts
                }));
            } catch (err) {
                console.error("Falha ao obter produtos: ", err);
            }
        }

        async function fetchCompProducts() {
            try {
                const comptData = await api.getCompProducts();
                const auxCompt = comptData.sort((a, b) => {
                    if (a['nome'] < b['nome']) return -1;
                    if (a['nome'] > b['nome']) return 1;
                    return 0;
                });
                setMapState(prevState => ({
                    ...prevState,
                    loadingCompet: false,
                    compProducts: auxCompt
                }));
            } catch (err) {
                console.error("Falha ao obter produtos competidores: ", err);
            }
        }

        fetchUsers();
        fetchOwntProducts();
        fetchCompProducts();
    }, []);

    return (
        <Container>
            <Side style={{ flex: '0 0 auto', width: 'auto' }}>
                <Sidebar page={"map"}></Sidebar>
            </Side>
            <Container>
                <HeaderRS>
                    <Navbarr></Navbarr>
                </HeaderRS>
                <Content style={{ backgroundColor: '#FAFAFA', padding: '5px' }}>
                    <CardMap mapState={mapState} />
                </Content>
                <Footer></Footer>
            </Container>
        </Container>
    );
} 